import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import Helmet from 'react-helmet';
import cx from 'classnames';
import {connect} from 'react-redux';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import {getRoutes} from '@epic-core/utils';
import {Alert} from './components';
import getRouteDefinitions from './routes/routes';
import {getMetaTags} from './utils/Utils';
import errorActions from './actions/error.actions';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';
//import {Nav} from './components';
import styles from './App.pcss';
import {ThemeProvider} from 'styled-components';
import {theme} from './theme';

const mapStateToProps = state => ({
    errorState: state.get('error').toJS()
});

const mapDispatchToProps = dispatch => ({
    hideErrorMessage: () => {
        dispatch(errorActions.hideErrorMessage());
    }
});

class App extends React.Component {
    static propTypes = {
        location: PropTypes.object.isRequired,
        messages: PropTypes.object,
        errorState: PropTypes.object,
        hideErrorMessage: PropTypes.func,
        getMessage: PropTypes.func
    };

    render() {
        const timeout = {
            enter: 1000,
            exit: 0
        };
        const {location, errorState, messages} = this.props;
        const locationKey = location.pathname;

        const tags = getMetaTags(messages);

        /* Needed for accurate styles while feed
           must support both embedded and global versions */
        const appClasses = cx(styles.app, 'global');
        return (
            <ThemeProvider theme={theme}>
                <div className={appClasses}>
                    <Helmet meta={tags} title={this.props.getMessage('epic.affiliate.name')} />
                    {/* <Nav isLoggedIn={true} /> */}
                    <div className={styles.container}>
                        <TransitionGroup>
                            <CSSTransition
                                key={locationKey}
                                timeout={timeout}
                                classNames="fade"
                                mountOnEnter={true}
                                unmountOnExit={true}>
                                <section>{getRoutes(getRouteDefinitions(), location)}</section>
                            </CSSTransition>
                        </TransitionGroup>
                        {
                            <Alert
                                show={errorState.show}
                                type="Danger"
                                closeable={true}
                                closeAlert={this.props.hideErrorMessage}
                                message={errorState.errorMessage}
                            />
                        }
                    </div>
                </div>
            </ThemeProvider>
        );
    }
}

export default withRouter(
    withLocalization(
        connect(
            mapStateToProps,
            mapDispatchToProps
        )(App)
    )
);
